module.exports = __webpack_public_path__ + "static/img/zy_default.58b8d3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zy_default.png
// module id = yc1x
// module chunks = 1